<template>
    <div class="q-ma-md" v-if="localModel">
        <p class="q-display-1" v-if="editMode">Edycja "{{localModel && localModel.label}}"</p>
        <p class="q-display-1" v-else-if="$store.getters.basePole">Definiowanie nowego bieguna</p>
        <p class="q-display-1" v-else>Definiowanie bieguna bazowego</p>

        <!--        <button @click="fixMissingTasklets">fix tasklets</button>-->

        <div v-if="localModel.phase === 1">
            Info. To jest biegun kwalifikacyjny. Bazując na dodanych ankiet możemy się stąd zakwalifikować do
            następujących biegunów:
            <ul>
                <li :key="pole.poleId" v-for="pole in targetPoles">
                    <router-link :to="{name: 'pole-edit', params: {poleId: pole.poleId}}">
                        {{pole.label}}
                    </router-link>
                    <publish-button :model="pole" what="pole"/>
                </li>

            </ul>
        </div>

        <!--        Przeanalizuj bieguj pod kątem kompletnośći danych: <q-btn size="sm" label="Analizuj bieguj" @click="analyseCompleteness"/>-->

        <q-timeline>
            <q-timeline-entry title="Uwaga!" v-if="unusableOrders.length > 0">
                Uwaga! W konfiguracji bieguna występują odnosniki do elementów artykułów lub ankiet
                których nie ma już w systemie (musiały zostać usunięte). Proponujemy usunąć te elementy. Jest ich
                {{unusableOrders.length}}. <a href="#" @click.prevent="removeUnusableTasklets">Usuń</a>.
            </q-timeline-entry>

            <q-timeline-entry title="Uwaga!" v-if="unpublishedTasklets.length > 0">
                Uwaga! W konfiguracji bieguna występują odnosniki do elementów artykułów lub ankiet
                ktore nie są opublikowane. Oto one:

                <div>
                    <span :key="e.id" v-for="e in unpublishedTasklets">
                        <SurveyComponent
                            class="survey"
                            :model="e"
                            v-if="e.surveyId"
                            :inline="true"/>

                        <article-component
                            class="article-component"
                            :inline="true"
                            :model="e"
                            v-if="e.articleId"/>
                    </span>
                </div>

                <!--                Jest ich {{unpublishedTasklets.length}}. <a href="#" @click.prevent="removeUnusableTasklets">Usuń</a>.-->
            </q-timeline-entry>

            <q-timeline-entry
                title="Intro">

                Tutaj defniujemy jak dany biegun prezentuje się na liście biegunów.

                <div class="q-ma-lg">
                    <PoleComponent
                        :model="localModel"
                        :in-edit="true"
                        v-if="localModel"
                        @save="save"
                        :isBasePole="isBasePole"/>
                </div>

            </q-timeline-entry>

            <q-timeline-entry title="Konfiguracja krokomierza" v-if="localModel.phase === 2">

                Zdefiniuj wygląd ekranów rozpoczynających krokomierz<br/>

                <div :key="`step-${index}`" v-for="(step, index) in [localModel.metricsStep]">
                    <div class="timeline-header"></div>

                    <div>
                        <div class="task-wrapper"
                             :key="task.poleStepTaskId"
                             v-for="(task, taskIndex) in step.tasks"
                             @dragover.prevent="() => {}"
                             @drop="e => addTaskletToTask(e, task, step, {allowedTypes: ['article']})"
                        >

                            <TaskComponent
                                :model="task"
                                :in-edit="localModel.deleted === undefined"
                                :inline="true"
                                :isBasePole="isBasePole"
                                :show-opt="false"
                                :show-delete-option="true"
                                :show-start-delayed-days="taskIndex !== 0"
                                :show-min-number-of-steps="true"
                                :show-average-speed="true"
                                @deleted="deleteTask(task, step)"/>

                            <draggable :list="task.order" style="display: inline;">
                                <q-card :inline="true" class="q-ma-md" v-for="(taskletId, index) in task.order"
                                        :key="index">
                                    <generic-viewer class="q-ma-md"
                                                    :draggable="true"
                                                    :inline="true"
                                                    v-if="allParts[taskletId] "
                                                    :articlePart="allParts[taskletId]"
                                                    :surveyQuestion="allParts[taskletId]"
                                                    :overrideBackgroundFromModel="task"/>
                                    <div class="text-right">
                                        <a href="#" @click.prevent="removePartFromOrder(taskletId, task)">Usuń</a>
                                    </div>
                                </q-card>
                            </draggable>
                        </div>

                        <q-icon
                            v-if="! isBasePole && (localModel.phase === 2 || localModel.phase === 1 && step.pos === 0)"
                            style="font-size: 2em" name="add_circle" color="primary"
                            @click.native="addStepometerTaskToStep(step)">
                            <q-tooltip anchor="top right">
                                Dodaj zadanie
                            </q-tooltip>
                        </q-icon>

                    </div>
                </div>
            </q-timeline-entry>

            <q-timeline-entry :key="`step-${index}`" v-for="(step, index) in steps"
                              :title="`Krok ${index+1} - ${STEP_NAMES[index+1]}`">

                <div class="timeline-header">
                    <div class="dash"></div>
                    <div :class='["step-picture-circle", {empty: !step.thumbUrl}]'
                         @dragover.prevent="() => {}"
                         @drop="e => stepThumbDrop(e, step)"
                    >
                        <img v-if="step.thumbUrl"
                             loading="lazy"
                             :src="`${$store.state.MEDIA_PREFIX_FOR_IMG}${step.thumbUrl}`"/>
                    </div>
                </div>

                <div v-if="step.tasks && step.tasks.length > 0">
                    Zadania w kroku {{index+1}}

                    <div class="task-wrapper"
                         :key="task.poleStepTaskId"
                         v-for="(task, taskIndex) in step.tasks"
                         @dragover.prevent="() => {}"
                         @drop="e => addTaskletToTask(e, task, step)"
                    >

                        <div class="text-right">
                            <a
                                href="#"
                                v-if="step.tasks.length > 1 && taskIndex > 0"
                                @click.prevent="moveTaskUp(step, task)"
                                title="Przenieś zadanie wyżej"
                            >
                                <q-icon name="arrow_upward" size="30px"/>
                            </a>
                            <a
                                href="#"
                                v-if="step.tasks.length > 1 && taskIndex < step.tasks.length-1"
                                @click.prevent="moveTaskDown(step, task)"
                                title="Przenieś zadanie niżej"
                            >
                                <q-icon name="arrow_downward" size="30px"/>
                            </a>
                        </div>

                        <TaskComponent
                            :model="task"
                            :in-edit="localModel.deleted === undefined"
                            :inline="true"
                            @deleted="deleteTask(task, step)"
                            :show-link-to-roadmap="!isBasePole && step.pos > 0"
                            :isBasePole="isBasePole"/>

                        <span v-if="task.extras.externalLink">
                            Zadanie ze zdefiniowanym linkiem mapy drogi nie może posiadać taskletów
                        </span>

                        <draggable :list="task.order" style="display: inline;" v-if="!task.extras.externalLink">
                            <q-card :inline="true" class="q-ma-md" v-for="(taskletId, index) in task.order"
                                    :key="index">
                                <generic-viewer class="q-ma-md"
                                                :draggable="true"
                                                :inline="true"
                                                v-if="allParts[taskletId] "
                                                :articlePart="allParts[taskletId]"
                                                :surveyQuestion="allParts[taskletId]"
                                                :overrideBackgroundFromModel="task"/>
                                <div class="text-right">
                                    <a href="#" @click.prevent="removePartFromOrder(taskletId, task)">Usuń</a>
                                </div>
                            </q-card>
                        </draggable>
                    </div>

                    <q-icon v-if="! isBasePole && (localModel.phase === 2 || localModel.phase === 1 && step.pos === 0)"
                            style="font-size: 2em" name="add_circle" color="primary"
                            @click.native="addTaskToStep(step)">
                        <q-tooltip anchor="top right">
                            Dodaj zadanie
                        </q-tooltip>
                    </q-icon>

                </div>
                <div v-else>
                    Brak zadań

                    <q-icon
                        style="font-size: 2em"
                        name="add_circle"
                        color="primary"
                        @click.native="addTaskToStep(step)">

                        <q-tooltip anchor="top right">
                            Dodaj zadanie
                        </q-tooltip>
                    </q-icon>
                </div>

            </q-timeline-entry>
        </q-timeline>

        <fixed-buttons>
            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="face"
                color="green"
                @click="loadThumbsFromJuniorPole"
                v-if="! isBasePole && localModel.deleted === undefined && localModel.phase >= 1 && localModel.group === 'junior' && juniorAnonymousPole">
                <q-tooltip anchor="top left">
                    Skopiuj buźki z bieguna junior niezalogowany
                </q-tooltip>
            </q-btn>

            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="face"
                color="orange"
                @click="loadThumbsFromSeniorPole"
                v-if="! isBasePole && localModel.deleted === undefined && localModel.phase >= 1 && localModel.group === 'senior' && seniorAnonymousPole">
                <q-tooltip anchor="top left">
                    Skopiuj buźki z bieguna senior niezalogowany
                </q-tooltip>
            </q-btn>

            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="reply"
                @click="loadBasePole"
                v-if="! isBasePole && localModel.deleted === undefined">
                <q-tooltip anchor="top left">
                    Skopiuj buźki oraz pionowy stream z bieguna bazowego
                </q-tooltip>
            </q-btn>

            <q-btn
                flat
                style="font-size: 1.5rem" dense
                icon="save"
                color="primary"
                v-if="localModel.deleted === undefined"
                @click="save">
                <q-tooltip anchor="top left">
                    Zapisz
                </q-tooltip>
            </q-btn>

        </fixed-buttons>

    </div>
</template>

<script>
    import QInput from 'quasar-framework/src/components/input/QInput'
    import PoleComponent from './PoleComponent'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QTimeline from 'quasar-framework/src/components/timeline/QTimeline'
    import QTimelineEntry from 'quasar-framework/src/components/timeline/QTimelineEntry'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'
    import TaskComponent from './TaskComponent'
    import TaskletComponent from './TaskletComponent'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import TaskletPlaceholderComponent from './TaskletPlaceholderComponent'
    import GenericViewer from './viewers/GenericViewer'
    import FixedButtons from '../FixedButtons'
    import draggable from 'vuedraggable'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import SurveyComponent from './SurveyComponent'
    import PublishButton from './PublishButton'

    export default {
        name: 'PoleEditor',
        components: {
            PublishButton,
            SurveyComponent,
            QCard,
            draggable,
            FixedButtons,
            GenericViewer,
            TaskletPlaceholderComponent,
            QBtn,
            TaskletComponent,
            TaskComponent, QTooltip, QIcon, QTimelineEntry, QTimeline, QEditor, PoleComponent, QInput,
        },
        data () {
            return {
                STEP_NAMES: {
                    1: 'Odkryj swój biegun',
                    2: 'Mapa drogi',
                    3: 'Najlepszą praktyką jest dobra teoria',
                    4: 'Wyjście poza schemat',
                    5: 'Wizualizacja jako metoda przygotowań',
                    6: 'Start',
                    7: 'Droga jest ważniejsza niż cel',
                    8: 'Dwa bieguny',
                    9: 'Nie osiedlaj się na biegunie',
                    10: 'Poznaj samego siebie',
                },
                newPoleComponent: {
                    label: 'Nowy biegun',
                    description: '',
                    isNew: true,
                    poleId: this.$uuid(),
                    thumbUrl: null,
                    movieUrl: null,
                    audioUrl: null,
                    group: 'junior',
                    phase: 2,
                    // background: undefined,
                    steps: Array(10).fill().map((value, index) => {
                        return this.createStep({pos: index, stepType: 'normal'})
                    }),
                },
                localModel: undefined,
                unpublishedTasklets: [],
                unusableOrders: [],
            }
        },
        mounted () {
            if (this.pole) {
                this.localModel = this.parsePoleModel(this.pole)
            } else {
                const model = this.parsePoleModel(this.newPoleComponent)
                this.localModel = {
                    ...model,
                    ...this.$route.params.group ? {group: this.$route.params.group} : {},
                    ...this.$route.params.phase !== undefined ? {phase: parseInt(this.$route.params.phase, 10)} : {},
                }
            }

            this.fetch()
            this.$store.commit('showRightMenu', true)
        },
        watch: {
            pole () {
                if (this.pole) {
                    this.localModel = this.parsePoleModel(this.pole)
                }
            },
        },
        destroyed () {
            this.$store.commit('showRightMenu', false)
        },
        computed: {
            targetPoles () {
                let allTargetPoles = []
                const getters = this.$store.getters;

                // check only tasklets from step 0
                this.localModel.steps[0].tasks.map(({tasklets = []}) => {
                    tasklets.filter(({taskletType}) => taskletType === 'survey').forEach(tasklet => {
                        getters.survey.filter(s => s.surveyId === tasklet.taskletId && s.qualifying).forEach(survey => {
                            const poles = getters.pole.filter(p => p.category === survey.category
                                && p.group === this.localModel.group && !p.deleted)
                            allTargetPoles = [...allTargetPoles, ...poles]
                        })
                    })
                })

                return allTargetPoles
            },
            editMode () {
                return this.$route.params.poleId
            },
            steps () {
                const arr = [...(this.localModel && this.localModel.steps || [])]
                arr.sort((a, b) => a.pos - b.pos)
                return arr
            },
            pole () {
                return this.$store.state.pole.find(p => p.poleId === this.$route.params.poleId)

                // if (this.editMode) {
                //     return this.$store.state.pole.find(p => p.poleId === this.$route.params.poleId)
                // }
                //
                // return this.newPoleComponent
            },
            allParts () {
                if (!this.localModel) {
                    return {}
                }

                const allSteps = [
                    ...this.localModel.steps,
                    ...this.localModel.metricsStep ? [this.localModel.metricsStep] : [],
                ]

                const all = allSteps.reduce((all, step) => {
                    return step.tasks.reduce((all, task) => {
                        return [...all, ...task.tasklets]
                    }, all)
                }, [])

                const resultMap = {}

                all.forEach(part => {
                    if (part.taskletType === 'article') {
                        const article = this.$store.getters.article.find(a => a.articleId === part.taskletId)
                        if (article) {
                            article.parts.forEach(part => {
                                resultMap[part.articlePartId] = part
                            })
                        }
                    } else if (part.taskletType === 'survey') {
                        const survey = this.$store.state.survey.find(a => a.surveyId === part.taskletId)
                        if (!survey) {
                            this.$store.dispatch('fetch', {
                                what: 'survey',
                                id: part.taskletId,
                            })
                        } else {
                            survey.questions.forEach(q => {
                                resultMap[q.surveyQuestionId] = q
                            })
                        }
                    }
                })

                return resultMap
            },
            basePole () {
                return this.$store.getters.basePole
            },
            juniorAnonymousPole () {
                return this.$store.getters.juniorAnonymousPole
            },
            seniorAnonymousPole () {
                return this.$store.getters.seniorAnonymousPole
            },
            isBasePole () {
                return this.basePole === undefined || this.localModel.poleId === this.$store.state.BASE_POLE_ID
            },
        },
        methods: {
            analyseCompleteness () {
                this.analyseUnpublishedStuff()
                this.analyzeMissingStuff()
            },
            analyseUnpublishedStuff () {
                if (!this.localModel) {
                    return []
                }

                let result = []

                const all = this.localModel.steps.reduce((all, step) => {
                    return step.tasks.reduce((all, task) => {
                        return [...all, ...task.tasklets]
                    }, all)
                }, [])

                all.forEach(part => {
                    if (part.taskletType === 'article') {
                        const article = this.$store.getters.article.find(
                            a => a.articleId === part.taskletId && a.publicationInformation &&
                                a.publicationInformation.status === 'Published')
                        if (!article) {
                            // result.push(part)
                            result.push(this.$store.getters.article.find(a => a.articleId === part.taskletId))
                        }
                    } else if (part.taskletType === 'survey') {
                        const survey = this.$store.state.survey.find(
                            a => a.surveyId === part.taskletId && a.publicationInformation &&
                                a.publicationInformation.status === 'Published')
                        if (!survey) {
                            // result.push(part)
                            result.push(this.$store.state.survey.find(a => a.surveyId === part.taskletId))
                        }
                    }
                })

                this.unpublishedTasklets = result
            },
            analyzeMissingStuff () {
                if (!this.localModel) {
                    return []
                }

                const allPossibleOrders = this.localModel.steps.reduce((all, step) => {
                    return [
                        ...all, ...step.tasks.reduce((p, task) => {

                            const x = [
                                ...p, ...(task.tasklets || []).reduce((pp, tasklet) => {
                                    if (tasklet.taskletType === 'survey') {
                                        const survey = this.$store.state.survey.find(
                                            a => a.surveyId === tasklet.taskletId)
                                        if (survey) {
                                            return [...pp, ...survey.questions.map(q => q.surveyQuestionId)]
                                        }
                                        return pp
                                    }
                                    if (tasklet.taskletType === 'article') {
                                        const article = this.$store.state.article.find(
                                            a => a.articleId === tasklet.taskletId)
                                        if (article) {
                                            return [...pp, ...article.parts.map(q => q.articlePartId)]
                                        }
                                        return pp
                                    }
                                }, [])]
                            return x
                        }, [])]
                }, [])

                const allOrders = this.localModel.steps.reduce((all, step) => {
                    return [
                        ...all, ...step.tasks.reduce((p, task) => {
                            return [...p, ...(task.order || [])]
                        }, [])]
                }, [])

                let result = []
                allOrders.forEach(id => {
                    if (allPossibleOrders.indexOf(id) === -1) {
                        result.push(id)
                    }
                })

                this.unusableOrders = result
            },
            // fixMissingTasklets() {
            //     // each tasklet in .tasklets has this:
            //     // taskletId: article.articleId,
            //     // parentId: task.poleStepTaskId,
            //     // taskletType: 'article',
            //
            //     const allSteps = [
            //         ...this.localModel.steps,
            //         ...this.localModel.metricsStep ? [this.localModel.metricsStep] : []
            //     ]
            //
            //     const allTasks = allSteps.reduce((all, step) => {
            //         return [...all, ...step.tasks]
            //     }, [])
            //
            //     // uuid is tasklet is and we need to find and return {taskletId, parentId, taskletType}
            //     const findTaskletFromUUID = (task, uuid) => {
            //         const allArticles = this.$store.getters.article
            //
            //         const allSurveys = this.$store.getters.survey;
            //
            //         const articles = allArticles
            //             .filter(a => a.parts.find(({articlePartId}) => articlePartId === uuid))
            //         if (articles.length === 1) {
            //             const article = articles[0]
            //             return {
            //                 taskletId: article.articleId,
            //                 parentId: task.poleStepTaskId,
            //                 taskletType: 'article',
            //             }
            //         } else {
            //             const surveys = allSurveys
            //                 .filter(a => a.questions.find(({surveyQuestionId}) => surveyQuestionId === uuid))
            //             if (surveys.length === 1) {
            //                 const survey = surveys[0]
            //                 return {
            //                     taskletId: survey.surveyId,
            //                     parentId: task.poleStepTaskId,
            //                     taskletType: 'survey',
            //                 }
            //             }
            //         }
            //     }
            //
            //     console.log(this.$store.state.article)
            //     allTasks.forEach(task => {
            //         task.order.forEach(uuid => {
            //             const tasklet = findTaskletFromUUID(task, uuid)
            //             if (tasklet) {
            //                 console.log("tasklet found")
            //                 const exists = (task.tasklets || []).filter(t => t.taskletId === tasklet.taskletId).length > 0
            //
            //                 if (! exists) {
            //                     task.tasklets = [...(task.tasklets || []), tasklet]
            //                 }
            //             } else {
            //                 console.log("tasklet not found")
            //             }
            //         })
            //     })
            // },
            fetch () {
                if (this.editMode) {
                    this.$store.dispatch('fetch', {
                        what: 'pole',
                        id: this.$route.params.poleId,
                    })
                }

                if (!this.basePole) {
                    this.$store.dispatch('fetch', {
                        what: 'pole',
                        id: this.$store.state.BASE_POLE_ID,
                    })
                }
            },
            parsePoleModel (pole) {
                const x = {
                    ...JSON.parse(JSON.stringify(pole)),
                    steps: pole.steps.map(s => ({
                        ...s,
                        tasks: s.tasks.map(t => {
                            return {
                                ...t,
                                shortMovieUrl: t.shortMovieUrl ||
                                    (!t.shortMovieUrl && !t.thumbUrl && !t.audioUrl && t.movieUrl ? t.movieUrl : ''),
                                movieUrl: undefined,
                            }
                        }),
                    })),
                    ...pole.metricsStep && pole.phase === 2 ? {
                        metricsStep: {
                            ...pole.metricsStep,
                            tasks: (pole.metricsStep.tasks || []).map(t => ({
                                ...t,
                                ...t.shortMovieUrl ? {shortMovieUrl: t.shortMovieUrl} : {shortMovieUrl: undefined},
                                movieUrl: undefined,
                            })),
                        },
                    } : {
                        metricsStep: {
                            ...this.createStep({
                                tasks: [
                                    // this.createMetricsTask({
                                    //     label: 'Krokomierz 1',
                                    //     pos: 0,
                                    // }),
                                    // this.createMetricsTask({
                                    //     label: 'Krokomierz 2',
                                    //     pos: 1,
                                    // })
                                ],
                                stepType: 'metrics',
                            }),
                            pos: 0,
                        },
                    },
                    extras: JSON.parse(JSON.stringify(pole.extras || {})),
                }

                return x
            },
            submit () {

            },
            reset () {
                this.fetch()
            },
            addTaskToStep (step) {
                const taskModel = this.createNewTask()
                step.tasks.push(taskModel)
            },
            addStepometerTaskToStep (step) {
                const taskModel = this.createMetricsTask({
                    label: 'Krokomierz',
                })
                step.tasks.push(taskModel)
            },
            createNewTask () {
                return {
                    poleStepTaskId: this.$uuid(),
                    poleStepId: '',
                    poleId: '',
                    label: 'Nowe zadanie',
                    description: '',
                    thumbUrl: '',
                    audioUrl: '',
                    movieUrl: '',
                    backgroundUrl: undefined,
                    opt: false,
                    order: [], // array of UUIDs or all tasklets
                    tasklets: [],
                    extras: {},

                    isNew: true,
                }
            },
            createMetricsTask (opts) {
                return {
                    ...this.createNewTask(),
                    ...opts,
                    extras: {
                        stepometer: {
                            active: true,
                        },
                    },
                }
            },
            createStep (opts) {
                return {
                    poleStepId: this.$uuid(),
                    poleId: '',
                    label: '',
                    description: '',
                    thumbUrl: '',
                    audioUrl: undefined,
                    movieUrl: undefined,
                    points: 10,
                    // pos: index, -> define in opts
                    tasks: [
                        {
                            ...this.createNewTask(),
                        },
                    ],
                    ...opts,
                }
            },
            createNewTasklet () {
                return {
                    id: this.$uuid(),
                    name: 'Nowy element',
                    description: '',
                    isNew: true,
                }
            },
            addTaskletToTask (e, task, step, opts = {allowedTypes: ['article', 'survey']}) {
                if (this.isBasePole) {
                    return
                }

                if (task.extras.externalLink) {
                    return
                }

                let tasklet

                try {
                    tasklet = JSON.parse(e.dataTransfer.getData('text'))
                    if (tasklet.type === 'article' || tasklet.type === 'survey') {
                        this.$emit('dropped', tasklet)
                    } else {
                        tasklet = undefined
                    }
                    // inline
                } catch (ee) {
                    // ...
                }

                if (!tasklet) {
                    return
                }

                if (!task.tasklets) {
                    this.$set(task, 'tasklets', [])
                }

                const taskletAllowed = opts.allowedTypes.indexOf(tasklet.type) !== -1
                if (taskletAllowed) {
                    if (tasklet.type === 'article') {
                        const article = tasklet

                        const exists = task.tasklets.filter(t => t.taskletId === article.articleId).length > 0

                        if (!exists) {
                            task.tasklets.push({
                                taskletId: article.articleId,
                                parentId: task.poleStepTaskId,
                                taskletType: 'article',
                                // backgroundUrl: ''
                            })
                        }

                        task.order = [...task.order, ...article.parts.map(p => p.articlePartId)]
                    } else if (tasklet.type === 'survey') {
                        const survey = tasklet

                        const exists = task.tasklets.filter(t => t.taskletId === survey.surveyId).length > 0

                        if (!exists) {
                            task.tasklets.push({
                                taskletId: survey.surveyId,
                                parentId: task.poleStepTaskId,
                                taskletType: 'survey',
                                // backgroundUrl: ''
                            })
                        }

                        if (this.localModel.phase === 1) { // do this only for a qualification
                            const allStepOrderItems = step.tasks.reduce((orderItems, t) => {
                                return [...orderItems || [], ...t.order || []]
                            }, [])

                            survey.questions.map(q => q.surveyQuestionId).forEach(questionId => {
                                if (allStepOrderItems.indexOf(questionId) === -1) {
                                    task.order.push(questionId)
                                }
                            })
                        } else {
                            task.order = [...task.order, ...survey.questions.map(q => q.surveyQuestionId)]
                        }
                    }
                }
            },
            removePartFromOrder (part, task) {
                task.order = task.order.filter(t => t !== part)

                const article = task.tasklets.filter(t => t.taskletType === 'article') // only article tasklets
                    .map(t => this.$store.getters.article.find(
                        a => a.articleId === t.taskletId)) // get full article models
                    .find(a => (a.parts || []).map(p => p.articlePartId).indexOf(part) !== -1) // get models that have our part

                if (article) {
                    // this means we've just removed part from article
                    // let's see if there's any part of this article in 'order'
                    // if not - we'll remove this article from tasklets too
                    const common = article.parts.map(p => p.articlePartId).filter(p => task.order.includes(p))
                    if (common.length === 0) {
                        task.tasklets = task.tasklets.filter(t => t.taskletId !== article.articleId)
                    }
                }

                const survey = task.tasklets.filter(t => t.taskletType === 'survey') // only survey tasklets
                    .map(t => this.$store.state.survey.find(s => s.surveyId === t.taskletId)) // get full survey models
                    .find(s => (s.questions || []).map(q => q.surveyQuestionId).indexOf(part) !== -1) // get models that have our question

                if (survey) {
                    // this means we've just removed part from survey
                    // let's see if there's any part of this survey in 'order'
                    // if not - we'll remove this survey from tasklets too
                    const common = survey.questions.map(q => q.surveyQuestionId).filter(q => task.order.includes(q))
                    if (common.length === 0) {
                        task.tasklets = task.tasklets.filter(t => t.taskletId !== survey.surveyId)

                    }
                }
            },
            deleteTask (task, step) {
                step.tasks = step.tasks.filter(t => t !== task)
            },
            save () {
                if (this.localModel) {
                    const pole = {...this.localModel}

                    if (!this.$store.getters.basePole && pole.isNew) {
                        pole.poleId = this.$store.state.BASE_POLE_ID
                    }

                    const completePoleModel = {
                        poleId: pole.poleId,
                        label: pole.label,
                        description: pole.description,
                        category: pole.category,
                        group: pole.group,
                        phase: pole.phase,
                        thumbUrl: pole.thumbUrl || '',
                        ...pole.audioUrl ? {audioUrl: pole.audioUrl} : {},
                        ...pole.movieUrl ? {movieUrl: pole.movieUrl} : {},
                        backgroundUrl: pole.backgroundUrl,
                        steps: pole.steps.map((step, stepIndex) => {
                            return {
                                ...step,
                                pos: stepIndex,
                                poleId: pole.poleId,
                                label: this.$store.state.STEP_NAMES[stepIndex + 1],
                                tasks: step.tasks.map((t, taskIndex) => {
                                    return {
                                        poleStepTaskId: t.poleStepTaskId,
                                        poleStepId: step.poleStepId,
                                        poleId: pole.poleId,
                                        label: t.label,
                                        description: t.description,
                                        thumbUrl: t.thumbUrl || '',
                                        ...t.audioUrl ? {audioUrl: t.audioUrl} : {},
                                        ...t.movieUrl ? {movieUrl: t.movieUrl} : {},
                                        ...t.shortMovieUrl ? {shortMovieUrl: t.shortMovieUrl} : {},
                                        order: !t.extras.externalLink && (t.order || []) || [],
                                        opt: t.opt,
                                        tasklets: !t.extras.externalLink && (t.tasklets || []) || [],
                                        backgroundUrl: t.backgroundUrl,
                                        backgroundColor: t.backgroundColor,
                                        pos: taskIndex,
                                        badges: t.badges || [],
                                        extras: {
                                            ...t.extras.externalLink ? {externalLink: t.extras.externalLink} : {},
                                        },
                                    }
                                }),
                            }
                        }),
                        ...pole.phase === 2 && (pole.metricsStep.tasks || []).length > 0 ? {
                            metricsStep: {
                                ...pole.metricsStep,
                                poleId: pole.poleId,
                                tasks: pole.metricsStep.tasks.map((t, tIndex) => ({
                                    ...t,
                                    thumbUrl: t.thumbUrl || '',
                                    poleId: pole.poleId,
                                    poleStepId: pole.metricsStep.poleStepId,
                                    extras: {
                                        ...tIndex !== 0 ? {startDelayedDays: t.extras.startDelayedDays} : {},
                                        stepometer: {
                                            active: true,
                                            minNumberOfSteps: t.extras.stepometer.minNumberOfSteps,
                                            averageSpeed: t.extras.stepometer.averageSpeed,
                                        },
                                    },
                                    badges: t.badges || [],
                                    pos: tIndex,
                                })),
                            },
                        } : {},
                    }

                    if (pole.isNew) {
                        this.$store.dispatch('create', {
                            what: 'pole',
                            item: completePoleModel,
                            id: completePoleModel.poleId,
                        }).then(() => {
                            this.$router.push({name: 'pole-edit', params: {poleId: completePoleModel.poleId}})
                        })

                    } else {
                        this.$store.dispatch('update', {
                            what: 'pole',
                            item: completePoleModel,
                            id: completePoleModel.poleId,
                        })
                    }
                }
            },
            loadBasePole () {
                if (this.basePole) {
                    this.basePole.steps.forEach((step, stepIndex) => {
                        this.localModel.steps = this.localModel.steps.map((s, i) => ({
                            ...s,
                            ...stepIndex === i ? {
                                tasks: s.tasks.map((task, taskIndex) => {
                                    return {
                                        ...task,
                                        ...taskIndex === 0 ? {
                                            label: step.tasks[0].label,
                                            description: step.tasks[0].description,
                                            thumbUrl: step.tasks[0].thumbUrl,
                                            movieUrl: step.tasks[0].movieUrl,
                                            shortMovieUrl: step.tasks[0].shortMovieUrl,
                                            audioUrl: step.tasks[0].audioUrl,
                                            backgroundUrl: step.tasks[0].backgroundUrl,
                                            backgroundColor: step.tasks[0].backgroundColor,
                                            badges: step.tasks[0].badges || [],
                                        } : {},

                                    }
                                }),
                            } : {},
                        }))
                    })
                }
            },
            loadThumbsFromJuniorPole () {
                this.loadThumbsFromPole(this.juniorAnonymousPole)
            },
            loadThumbsFromSeniorPole () {
                this.loadThumbsFromPole(this.seniorAnonymousPole)
            },
            loadThumbsFromPole (pole) {
                if (pole) {
                    pole.steps.forEach((step, sIndex) => {
                        this.localModel.steps = this.localModel.steps.map((s, i) => ({
                            ...s,
                            ...sIndex === i ? {thumbUrl: step.thumbUrl} : {},
                        }))
                    })
                }

            },
            stepThumbDrop (e, step) {
                try {
                    const json = JSON.parse(e.dataTransfer.getData('text'))
                    if (json.type === 'picture') {
                        step.thumbUrl = json.urlPath
                    }
                } catch (e) {
                    // ...
                }
            },
            moveTaskUp (step, task) {
                const index = step.tasks.indexOf(task)
                step.tasks[index] = step.tasks[index - 1]
                step.tasks[index - 1] = task
                step.tasks = [...step.tasks]
            },
            moveTaskDown (step, task) {
                const index = step.tasks.indexOf(task)
                step.tasks[index] = step.tasks[index + 1]
                step.tasks[index + 1] = task
                step.tasks = [...step.tasks]
            },
            removeUnusableTasklets () {
                // this.unusableOrders;
                this.localModel.steps = this.localModel.steps.map(step => ({
                    ...step,
                    tasks: step.tasks.map(task => ({
                        ...task,
                        tasklets: task.tasklets.filter(tasklet => {
                            if (tasklet.taskletType === 'article') {
                                return this.$store.getters.article.find(
                                    ({articleId}) => articleId === tasklet.taskletId)
                            } else if (tasklet.taskletType === 'survey') {
                                return this.$store.state.survey.find(({surveyId}) => surveyId === tasklet.taskletId)
                            }
                            return true
                        }),
                    })),
                }))

                alert('Zrobione. Pamiętaj o zapisaniu bieguna!')
            },
        },
    }
</script>

<style scoped lang="scss">
    .task-wrapper {
        border: 2px solid gray;
        border-radius: 10px;
        margin-bottom: 10px;

        .task {

        }
    }

    .viewer-wrapper {
        display: inline-block;
        border: 1px solid gray;
        border-radius: 10px;
    }

    .timeline-header {
        position: relative;

        .dash {
            border: 1px dashed gray;
        }

        .step-picture-circle {
            position: absolute;
            position: absolute;
            top: -40px;
            right: 40px;
            background: #fff;
            width: 80px;
            height: 80px;
            border-radius: 50%;
            overflow: hidden;

            &.empty {
                border: 2px dashed red;
            }

            img {
                width: 100%;
                height: 100%;
            }
        }
    }
</style>